import { render, staticRenderFns } from "./RelaxationProtocolBackgroundCard.vue?vue&type=template&id=06e88c71&scoped=true&"
import script from "./RelaxationProtocolBackgroundCard.vue?vue&type=script&lang=js&"
export * from "./RelaxationProtocolBackgroundCard.vue?vue&type=script&lang=js&"
import style0 from "./RelaxationProtocolBackgroundCard.vue?vue&type=style&index=0&id=06e88c71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e88c71",
  null
  
)

export default component.exports